import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const FailSelected = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // 토스페이먼츠가 쿼리 스트링으로 보내주는 에러 정보
  const message = searchParams.get('message') || '결제 중 알 수 없는 오류가 발생했습니다.';
  const code = searchParams.get('code') || 'UNKNOWN_ERROR';
  const orderId = searchParams.get('order_id'); // 우리 DB의 주문 번호

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.iconArea}>
          <span style={styles.errorIcon}>!</span>
        </div>
        
        <h2 style={styles.title}>결제 실패</h2>

        <div style={styles.infoBox}>
          <div style={styles.infoRow}>
            <span style={styles.label}>에러 메시지</span>
            <p style={styles.value}>{message}</p>
          </div>
          <div style={styles.infoRow}>
            <span style={styles.label}>에러 코드</span>
            <p style={styles.codeText}>{code}</p>
          </div>
          {orderId && (
            <div style={styles.infoRow}>
              <span style={styles.label}>주문 번호</span>
              <p style={styles.value}>{orderId}</p>
            </div>
          )}
        </div>

        <div style={styles.buttonGroup}>
          <button 
            style={styles.cartBtn} 
            onClick={() => navigate('/cart')} // 장바구니로 돌아가기
          >
            장바구니로 돌아가기
          </button>
          <button 
            style={styles.homeBtn} 
            onClick={() => navigate('/')} // 메인으로 (Flask의 main.index 대응)
          >
            메인으로 이동
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: { 
    backgroundColor: '#ffffff', 
    minHeight: '0vh', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    padding: '0px' 
  },
  card: { 
    maxWidth: '450px', 
    width: '100%', 
    background: '#fff', 
    padding: '40px 30px', 
    borderRadius: '2px', 
    textAlign: 'center' 
  },
  iconArea: { marginBottom: '20px' },
  errorIcon: { 
    display: 'inline-block', 
    width: '60px', 
    height: '60px', 
    lineHeight: '60px', 
    backgroundColor: '#ff4d4f', 
    color: '#fff', 
    borderRadius: '50%', 
    fontSize: '30px', 
    fontWeight: 'bold' 
  },
  title: { fontSize: '22px', fontWeight: 'bold', marginBottom: '30px', color: '#333' },
  infoBox: { 
    textAlign: 'left', 
    backgroundColor: '#fcfcfc', 
    padding: '20px', 
    borderRadius: '12px', 
    marginBottom: '30px',
    border: '1px solid #eee'
  },
  infoRow: { marginBottom: '15px' },
  label: { fontSize: '13px', color: '#8c8c8c', display: 'block', marginBottom: '4px' },
  value: {
    fontSize: '15px',
    color: '#434343',
    margin: 0,
    fontWeight: '500',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere'
  },
  codeText: {
    fontSize: '14px',
    color: '#cf1322',
    margin: 0,
    fontFamily: 'monospace',
    wordBreak: 'break-all',
    overflowWrap: 'anywhere'
  },
  buttonGroup: { display: 'flex', flexDirection: 'column', gap: '10px' },
  retryBtn: { 
    width: '100%', 
    padding: '16px', 
    backgroundColor: '#0073e9', 
    color: '#fff', 
    border: 'none', 
    borderRadius: '8px', 
    fontWeight: 'bold', 
    fontSize: '16px', 
    cursor: 'pointer' 
  },
  cartBtn: {
    width: '100%', 
    padding: '14px', 
    backgroundColor: '#212529', 
    color: '#fff', 
    border: 'none', 
    borderRadius: '8px', 
    fontSize: '14px', 
    cursor: 'pointer' 
  },
  homeBtn: { 
    width: '100%', 
    padding: '14px', 
    backgroundColor: '#fff', 
    color: '#595959', 
    border: '1px solid #d9d9d9', 
    borderRadius: '8px', 
    fontSize: '14px', 
    cursor: 'pointer' 
  }
};

export default FailSelected;